import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import Header from '../Header';

export default function Layout() {
  return (
    <>
      <Header logoSrc="/images/logo.svg" variant="cs_white_color cs_color_1" />
      <Outlet />
      <Footer />
    </>
  );
}
